export enum SoldOutLabel {
	Unavailable = "Unavailable",
	SoldOut = "SoldOut",
}
